import React, { useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";
import { customReactSelectStyles } from "./medication-select";
import { FORM_OPTIONS } from "../../service-steps/clinical-assessment/data";

const FormSelect = ({
  onChange = () => {},
  selectedMedicine = {
    doseOptions: [],
    dose: null,
    formOptions: [],
    form: null,
    routeOptions: [],
    route: null,
  },
  isRequired = false, // Add the new prop here
  error = false,
  value: actualValue = { value: "", label: "" },
  isDisabled = false,
}) => {
  // Prepare options based on conditions

  let defaultOptions = [];
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState(defaultOptions);
  const [value, setValue] = useState(null);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    const { formOptions, form } = selectedMedicine;
    if (formOptions && formOptions.length > 0) {
      const mapped = formOptions.map((option) => ({
        label: option,
        value: option,
      }));
      setOptions(mapped);
      // If there's already a value selected, preserve it and notify parent
      if (actualValue?.value) {
        const match = mapped.find((o) => o.value === actualValue.value) || actualValue;
        setValue(match);
        setShowError(false);
        onChange(match);
      } else {
        setValue(null);
      }
    } else if (form) {
      defaultOptions = [
        { label: form, value: form },
      ];
      setValue(defaultOptions[0]);
      setShowError(false);
      onChange(defaultOptions[0]);
      setOptions(defaultOptions);
    } else {
      // No medicine-specific options — show full flat defaults
      setOptions(FORM_OPTIONS);
      setValue(null);
      setShowError(true);
    }
  }, [selectedMedicine]);

  const handleCreate = (inputValue) => {
    setIsLoading(true);
    setTimeout(() => {
      const newOption = {
        label: inputValue,
        value: inputValue,
      };
      setIsLoading(false);
      setOptions((prevOptions) => [...prevOptions, newOption]);
      setValue(newOption);
      setShowError(isRequired && !newOption); // Show error if required and no new option
      onChange(newOption);
    }, 300);
  };

  const handleBlur = () => {
    if (isRequired && !value) {
      setShowError(true);
    } else {
      setShowError(false);
    }
  };

  useEffect(() => {
    if (actualValue?.value) {
      setValue(actualValue);
    } else {
      setValue(null);
    }
  }, [actualValue]);

  useEffect(() => {
    if (error) {
      setShowError(true);
    } else {
      setShowError(false);
    }
  }, [error]);

  return (
    <div className="w-full col-span-4">
      <div
        className={`relative rounded-[4px] border-[1px] ${
          showError ? "border-red-200" : "border-gray-100"
        } ${isDisabled ? 'pointer-events-none opacity-70': ''} ${!isDisabled && isRequired && value === null ? "bg-blue-100" : "bg-white"} px-3 py-3 focus-within:border-REELTeal focus-within:border-[2px]`}
      >
        {" "}
        <div className="">
          <span className="block mb-1 text-gray-900 text-body-xs">
            Form {isRequired && <span className="">*</span>}
          </span>
          <CreatableSelect
            isClearable
            styles={customReactSelectStyles(isRequired, value)}
            isDisabled={isLoading || isDisabled}
            isLoading={isLoading}
            onChange={(newValue) => {
              setValue(newValue);
              setShowError(isRequired && !newValue);
              onChange(newValue);
            }}
            onCreateOption={handleCreate}
            onBlur={handleBlur}
            options={options}
            value={value}
            placeholder="Select form"
            className="col-span-4"
            isValidNewOption={(inputValue) =>
              !!inputValue && inputValue.trim() !== ""
            }
          />
        </div>
      </div>
      {showError && (
        <span className="block mt-1 text-red-200 text-body-xs">
          Form is required
        </span>
      )}
    </div>
  );
};

export default FormSelect;
